<template>
  <div id="app">
    <div class="sticky-nav px-4">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">Gebruikers</h1>
      </div>

      <div class="dropdown">
        <button
          class="btn btn-dark"
          type="button"
          id="dropdownMenuButton"
          v-on:click="modalToevoegenGebruiker()"
        >
          <i class="fas fa-plus"></i> Gebruiker toevoegen
        </button>
      </div>
    </div>

    <br />
    <br />

    <vue-good-table
      v-if="gebruikers && gebruikers.length"
      class="mb-3 px-4"
      @on-selected-rows-change="selectionChanged"
      @on-cell-click="onRowClick"
      :columns="gebruikerColumns"
      :rows="gebruikers"
      :pagination-options="{
            enabled: true,
            mode: 'pages',
            perPage: 100,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
            dropdownAllowAll: true,
          }"
      :selectOptions="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
          }"
    />

    <!-- Modal -->
    <div
      class="modal fade"
      id="gebruikerModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ editModalTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="gebruiker">
              <label>Naam</label>
              <input type="text" class="form-control" v-model="gebruiker.naam" placeholder="Naam" />
              <label>Voornaam</label>
              <input
                type="text"
                class="form-control"
                v-model="gebruiker.voornaam"
                placeholder="Voornaam"
              />
              <label>E-mail</label>
              <input
                type="text"
                class="form-control"
                v-model="gebruiker.email"
                placeholder="E-mail"
              />
              <label>Type</label>
              <select class="form-control" v-model="gebruiker.type">
                <option value>- Kies gebruikerstype -</option>
                <option value="Administrator">Administrator</option>
                <option value="Chauffeur">Chauffeur</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="checkNewGebruiker === false"
              type="button"
              class="btn btn-danger"
              v-on:click="deleteGebruiker()"
            >Verwijderen</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Sluiten</button>
            <button
              v-if="checkNewGebruiker"
              type="button"
              class="btn btn-primary"
              v-on:click="createGebruiker()"
            >Opslaan</button>
            <button
              v-else
              type="button"
              class="btn btn-primary"
              v-on:click="updateGebruiker()"
            >Aanpassen</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "bootstrap";
import axios from "axios";

export default {
  name: "app",
  components: {},
  data() {
    return {
      checkNewGebruiker: false,
      importType: "-1",
      importCategory: "-1",
      types: [
        {
          name: "Gebruikers",
        },
        {
          name: "Gebruikers",
        },
        {
          name: "Leveradressen",
        },
      ],
      editModalTitle: "",
      gebruiker: {},
      klanten: {},
      gebruikers: {
        attributes: [],
        related: [],
      },
      gebruikerColumns: [
        { label: "Naam", field: "naam", filterOptions: { enabled: true } },
        {
          label: "Voornaam",
          field: "voornaam",
          filterOptions: { enabled: true },
        },
        { label: "Email", field: "email", filterOptions: { enabled: true } },
        { label: "Type", field: "type", filterOptions: { enabled: true } },
      ],
      attrPos: 0,
    };
  },
  mounted() {
    this.getGebruikers();
    this.getKlanten();
  },
  methods: {
    klantFn(rowObj) {
      var klanten = this.klanten;
      var klant_id = rowObj.klant;

      for (var i = 0; i < klanten.length; i++) {
        if (klanten[i]["id"] == klant_id) {
          return klanten[i]["bedrijfsnaam"];
        }
      }
    },
    getGebruikers() {
      axios
        .get("https://hofman.weblion.be/api/gebruikers/")
        .then((response) => {
          this.gebruikers = response.data;
          console.log(this.gebruikers);
        });
    },
    getKlanten() {
      axios.get("https://hofman.weblion.be/api/klanten/").then((response) => {
        this.klanten = response.data;
        console.log(this.gebruikers);
      });
    },
    deleteGebruiker() {
      axios
        .delete("https://hofman.weblion.be/api/gebruikers/", {
          data: {
            gebruiker_id: this.gebruiker.id,
          },
        })
        .then((response) => {
          this.getGebruikers();
          $("#gebruikerModal").modal("hide");
          console.log(response.data);
        });
    },
    updateGebruiker() {
      axios
        .put("https://hofman.weblion.be/api/gebruikers/", {
          gebruiker: this.gebruiker,
        })
        .then((response) => {
          this.getGebruikers();
          $("#gebruikerModal").modal("hide");
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    createGebruiker() {
      axios
        .post("https://hofman.weblion.be/api/gebruikers/", {
          gebruiker: this.gebruiker,
        })
        .then((response) => {
          this.getGebruikers();
          $("#gebruikerModal").modal("hide");
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    modalToevoegenGebruiker() {
      this.gebruiker = {};
      this.editModalTitle = "Gebruiker toevoegen";

      this.checkNewGebruiker = true;

      $("#gebruikerModal").modal("show");
    },
    onRowClick(table) {
      this.editModalTitle = "Gebruiker aanpassen";
      this.gebruiker = table.row;

      this.checkNewGebruiker = false;

      $("#gebruikerModal").modal("show");
    },
    selectionChanged(table) {
      this.gebruikersSelected = table.selectedRows;
    },
    modalAanpassenGebruiker() {
      this.checkNewGebruiker = false;
      this.editModalTitle = "Gebruiker aanpassen";

      $("#gebruikerModal").modal("show");
    },
    sGebruiker() {
      axios
        .post("https://hofman.weblion.be/api/gebruikers/update.php", {
          gebruiker: this.gebruiker,
        })
        .then((res) => {
          console.log(res);
          this.getGebruikers();
        })
        .then(function () {
          $("#gebruikerModal").modal("hide");
        });
    },
  },
};
</script>

<style>
button {
  margin-right: 10px;
}
.table thead th {
  text-align: left !important;
}
.pager ul {
  list-style-type: none;
}
.pager ul li {
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}
.modal input,
.modal select {
  margin-bottom: 5px;
}
.modal-body label {
  display: inline-block;
  width: 32%;
}

.modal-body .form-control {
  display: inline-block;
  width: 68%;
}

.modal-body select {
  text-indent: 5px;
}

#exampleModal input {
  display: block;
  width: 100%;
}

#importModal .modal-body label {
  width: auto;
}

#importModal input,
#importModal select {
  display: inline-block;
  width: 49%;
  margin-bottom: 5px;
}

#importModal .match-wrapper,
#importModal form {
  width: 100%;
}
#importModal select {
  margin-left: 1%;
}

#importModal .fullw {
  display: block;
  width: 100%;
  border-radius: 4px;
}

#importModal .fullw select {
  margin: 0;
}

#importModal .fullw input {
  display: block;
  width: 100%;
  margin: 0;
}

.dropdown {
  display: inline-block;
}
.dropdown-item:hover {
  cursor: pointer !important;
}
.dropdown-item i {
  margin-right: 3px;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 550px;
    margin: 1.75rem auto;
  }
}
.groupedState {
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin-left: 25%;
}

#autoGroupModal table tr td {
  padding: 2px 10px;
}

#autoGroupModal .modal-title span {
  color: #777;
  font-size: 14px;
  margin-left: 10px;
}

#autoGroupModal input {
  width: 100%;
}

#autoGroupModal .form-check-input {
  width: auto;
  position: relative;
  margin: 0;
  vertical-align: 2px;
}

.ck.ck-editor {
  display: inline-block !important;
  width: 68% !important;
  margin-bottom: 5px !important;
}

.sticky-nav {
  position: fixed;
  height: 150px;
  top: 50;
  z-index: 2;
  background: white;
  padding-top: 10px;
  width: 100%;
  margin-top: -10px;
}

#gebruikerModal textarea {
  height: 100px;
}

.vgt-wrap {
  margin-top: 120px;
}

label {
  vertical-align: top;
}

[data-g="1"] {
  background: #8cc040;
}

[data-g="0"] {
  background: red;
}
.btn-danger {
  margin-right: 210px;
}
</style>
